import Vue from 'vue'

function loadScript(script) {
  return new Promise((resolve, reject) => {
    const newScript = document.createElement('script')

    if (script.src) {
      for (const attr of script.attributes) {
        newScript.setAttribute(attr.name, attr.value)
      }

      newScript.onload = resolve
      newScript.onerror = reject
    } else {
      const inlineScript = document.createTextNode(script.innerHTML)
      newScript.appendChild(inlineScript)
      resolve()
    }

    script.parentNode.replaceChild(newScript, script)
  })
}
Vue.directive(
  'safe-html',
  (() => {
    return {
      update: function (el, binding) {
        if (binding.value !== binding.oldValue) {
          el.innerHTML = binding.value

          const loadScirpSequentially = async () => {
            const scripts = el.getElementsByTagName('script')

            for (const script of scripts) {
              await loadScript(script)
            }
          }

          loadScirpSequentially()
        }
      },
    }
  })()
)
